var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-element-loading',{attrs:{"active":_vm.$store.state.appLoading,"is-full-screen":!!!_vm.contain,"background-color":"#FFFFFF","color":"black","spinner":"bar-fade-scale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }